import { useAppConfig } from "src/components/providers/AppConfigProvider";

import { RedirectToPlanButton } from "src/components/features/SmartLibrary/SmartLibrary.styled";
import { NextPlanData } from "src/components/features/SmartLibrary/smartLibrary.types";
import styled from "styled-components/macro";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
`;

const TextWrapper = styled.div`
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  width: 150px;
  height: auto;
  text-align: center;
`;

interface FootageExpiredExplanationProps {
  nextClosestPlanData?: NextPlanData;
  action?: () => void;
}

export default function FootageExpiredExplanation({ nextClosestPlanData, action }: FootageExpiredExplanationProps) {
  const { FOOTAGE_EXPIRED } = useAppConfig();

  return (
    <Container>
      <TextWrapper>{FOOTAGE_EXPIRED.text}</TextWrapper>
      {action && (
        <RedirectToPlanButton onClick={action}>{`Upgrade to ${nextClosestPlanData?.name} plan`}</RedirectToPlanButton>
      )}
    </Container>
  );
}
